import React, { useEffect, useState } from "react";
// 1. Make sure ConfigProvider is imported alongside Select and Spin
import { Select, Spin, ConfigProvider } from "antd"; 
import Avatar from "./Avatar";
import { baseUrl } from "../../../config";
import api from "../../../utils/api";

export default function ChatHeader({ chat, onTemplateSelect }) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      setLoading(true);
      try {
        const response = await api.get(baseUrl + "/crm/template");
        const templateList = response?.data?.data || response?.data || [];
        setTemplates(templateList);
      } catch (error) {
        console.error("Failed to load MateCareer WhatsApp templates:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchTemplates();
  }, []);

  const handleDropdownChange = (value) => {
    if (onTemplateSelect) {
      onTemplateSelect(value);
    }
  };

  return (
    <div style={styles.bar}>
      <div style={styles.left}>
        <Avatar
          initials={chat?.initials}
          color={chat?.avatarColor}
          size={38}
          showOnline={chat?.isOnline}
        />
        <div style={styles.info}>
          <span style={styles.name}>{chat?.name}</span>
          <span style={styles.status}>
            {chat?.isOnline ? "online" : "last seen recently"}
          </span>
        </div>
      </div>
 
      <div style={styles.actions}>
        {/* 2. Wrap the Select component with ConfigProvider to override the token styles */}
<ConfigProvider
  theme={{
    components: {
      Select: {
        // Selection box styling (main header row)
        selectorBg: '#2b2b2bff',           // Grey background box
        selectorBorderColor : "#2b2b2bff",
        colorText: '#ffffff',            // White text for selected item
        colorTextPlaceholder: '#cbd5e1', // Light grey placeholder

        // --- Border Controls (Fixes the White & Blue hover effect) ---
        colorBorder: '#1e293b',          // Neutral medium gray resting border line
        colorPrimaryHover: '#1e293b',    // Lighter gray border outline when mouse hovers (instead of blue)
        colorPrimary: '#1e293b',         // Lighter gray border outline when focused/active (instead of blue)
        
        // Dropdown menu menu overlay options list panel
        optionBg: '#1e293b',             // White background for the choices menu panel
        colorTextDescription: '#1e293b', // Primary fallback color rule text boundary
        optionActiveBg: '#1e293b',       // Light grey background when hovering over an option
        optionSelectedBg: '#63666a',     // Grey background when an option is selected
        optionSelectedColor: '#1e293b',  // White text color for the actively selected list option
      },
    },
  }}
>
  <Select
    placeholder="select template"
    loading={loading}
    onChange={handleDropdownChange}
    style={styles.templateSelect}
    dropdownStyle={styles.dropdownMenu}
    variant="outlined"
    allowClear
    notFoundContent={loading ? <Spin size="small" /> : "No templates found"}
    options={templates.map((tpl) => ({
      value: tpl.id,
      label: tpl.templateName || tpl.name || `Template ${tpl.id}`,
      rawData: tpl
    }))}
  />
</ConfigProvider>
      </div>
    </div>
  );
}
 
function IconBtn({ children, title }) {
  return (
    <button style={styles.iconBtn} title={title}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {children}
      </svg>
    </button>
  );
}
 
const styles = {
  bar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 16px",
    borderBottom: "1px solid #1e293b",
    background: "#000000ff",
    flexShrink: 0,
  },
  left: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  info: {
    display: "flex",
    flexDirection: "column",
  },
  name: {
    fontSize: 15,
    fontWeight: 600,
    color: "#f6f7f9ff",
    lineHeight: 1.3,
  },
  status: {
    fontSize: 12,
    color: "#22c55e",
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  templateSelect: {
    width: 300,
    marginRight: 40,
    borderRadius: '6px',
  },
  dropdownMenu: {
    zIndex: 9999,
    background: "#2b2b2bff"
  },
  iconBtn: {
    background: "none",
    border: "none",
    borderRadius: 8,
    width: 34,
    height: 34,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "background 0.15s",
  },
};